import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiAward, FiCheckCircle} = FiIcons;
const PHOTO = 'https://media-manager-c.questera.ai/greta-media/8a70ca51af2d25ce7a8315899c53350503072ac0455482e7876f24d86c3df87814a475346bbe14751261db5845097a6d/images/aW1hZ2UvanBlZw==/c8f9260dbf598055f9f14f0727453267.jpeg';

function InstructorSection() {
  return (
    <section className="instructor-section section-pad" id="about">
      <div className="instructor-grid page-width">
        <motion.div className="instructor-image-wrap" initial={{opacity: 0, x: -24}} whileInView={{opacity: 1, x: 0}} viewport={{once: true, amount: 0.2}} transition={{duration: 0.6}}>
          <img src={PHOTO} alt="Milan Pathak, RSS Driving School instructor" />
          <div className="image-caption"><SafeIcon icon={FiAward} /> Milan Pathak</div>
        </motion.div>
        <motion.div className="instructor-copy" initial={{opacity: 0, x: 24}} whileInView={{opacity: 1, x: 0}} viewport={{once: true, amount: 0.2}} transition={{duration: 0.6}}>
          <span className="eyebrow">Meet your instructor</span>
          <h2>Steady guidance. <span>Stronger confidence.</span></h2>
          <p className="instructor-name">Milan Pathak <span>RSS Driving School Instructor</span></p>
          <p>Milan operates as RSS Driving School in NSW, Australia, offering calm, supportive automatic driving instruction for learners at different stages. Whether you are getting behind the wheel for the very first time or preparing for your driving test, RSS Driving School welcomes both new and test-ready students. All lessons take place in a safe, automatic dual-control vehicle so you can learn fast and feel secure on the road.</p>
          <ul className="check-list">
            <li><SafeIcon icon={FiCheckCircle} /> Lessons tailored to your stage</li>
            <li><SafeIcon icon={FiCheckCircle} /> Patient coaching, without the pressure</li>
            <li><SafeIcon icon={FiCheckCircle} /> Automatic dual-control vehicle</li>
          </ul>
          <a className="text-link" href="tel:0433037815">Talk with Milan <span>↗</span></a>
        </motion.div>
      </div>
    </section>
  );
}

export default InstructorSection;